/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-extra-boolean-cast */

import { environment as environmentProd } from 'src/environments/environment.prod';
import { environment as environmentProd2 } from 'src/environments/environment.prod2';
import { environment as environmentAramark_Prod } from 'src/environments/environment.aramark-prod';
import { environment as environmentAramark_Staging } from 'src/environments/environment.aramark-stg';
import { environment as environmentStag } from 'src/environments/environment.stg';
import { environment as environmentStag2 } from 'src/environments/environment.stg2';
import { ModeType } from 'src/app/enums/mode-type.enum';
import { RegionType } from 'src/app/enums/region-type.enum';

export interface IappClient {
  id: string;
  urlTLMiddleware: string;
  urlOmni: string;
}

export interface EnvironmentSetting {
  userPoolId: string;
  region: string;
  regionName: string;
  appClients: IappClient[];
}

export const SSMValues = {
  [ModeType.Prod]: {
    [RegionType.AUS]: environmentProd.Aus,
    [RegionType.USA]: environmentProd.US,
  },
  [ModeType.Staging]: {
    [RegionType.AUS]: environmentStag.Aus,
    [RegionType.USA]: environmentStag.US,
  },
  [ModeType.Prod2]: {
    [RegionType.AUS]: environmentProd2.Aus,
    [RegionType.USA]: environmentProd2.US,
  },
  [ModeType.Aramark_Prod]: {
    [RegionType.USA]: environmentAramark_Prod.US,
  },
  [ModeType.Aramark_Staging]: {
    [RegionType.USA]: environmentAramark_Staging.US,
  },
  [ModeType.Staging2]: {
    [RegionType.AUS]: environmentStag2.Aus,
    [RegionType.USA]: environmentStag2.US,
  },
};

export class EnvironmentData {
  constructor() {}
  public static version = {
    versionNumber: '24.09.0.4',
  };

  // TODO IMPROVE PERFORMANCES
  private static CURRENT_URL_OMNI: string;
  private static CURRENT_TL_URL: string;

  // private static environments: EnvironmentSetting[] = []

  static setEnvironmentSwitcher(mode: ModeType): void {
    localStorage.setItem('ModeType', mode.toString());
  }

  static getEnvironmentSwitcher(): any {
    const switcherEnv = localStorage.getItem('ModeType');
    if (!!switcherEnv) {
      return switcherEnv;
    } else {
      return null;
    }
  }

  static getAppClientId(): string {
    const settings = JSON.parse(localStorage.getItem('adminSettings'));
    if (!!settings) {
      return settings.appClientId;
    } else {
      return null;
    }
  }

  static getRegion(): string {
    const settings = JSON.parse(localStorage.getItem('adminSettings'));
    if (!!settings) {
      return settings.region;
    } else {
      return null;
    }
  }

  static getUserPool(): EnvironmentSetting {
    const env = this.getCurrentEnvs();
    if (!!env) {
      if (env.length > 0) {
        return env[0];
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  static getUserPoolByRegion(region: string): EnvironmentSetting {
    const env = this.getCurrentEnvs();
    if (!!env) {
      const userPool = env.find((pool) => pool.region === region);
      if (!!userPool) {
        return userPool;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  static getUserPoolByAppClient(appClientId: string): EnvironmentSetting {
    const env = this.getCurrentEnvs();
    if (!!env) {
      const userPool = env.find((pool) => {
        const user = pool.appClients.find((el) => el.id === window.btoa(appClientId));
        return !!user;
      });
      if (!!userPool) {
        return userPool;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  static getHubUrl(): string {
    if (!this.CURRENT_URL_OMNI) {
      const env = this.getCurrentEnvs();
      if (!!env) {
        const appClientId = this.getAppClientId();
        if (!!appClientId) {
          const appClient = this.getAppClientSettings();
          if (!!appClient) {
            this.CURRENT_URL_OMNI = appClient.urlOmni;
            return appClient.urlOmni;
          } else {
            return '';
          }
        } else {
          return '';
        }
      } else {
        return '';
      }
    } else {
      return this.CURRENT_URL_OMNI;
    }
  }

  static getTLUrl(): string {
    if (!this.CURRENT_TL_URL) {
      const env = this.getCurrentEnvs();
      if (!!env) {
        const appClientId = this.getAppClientId();
        if (!!appClientId) {
          const appClient = this.getAppClientSettings();
          if (!!appClient) {
            this.CURRENT_TL_URL = appClient.urlTLMiddleware;
            return appClient.urlTLMiddleware;
          } else {
            return '';
          }
        } else {
          return '';
        }
      } else {
        return '';
      }
    } else {
      return this.CURRENT_TL_URL;
    }
  }

  static getAppClientSettings(): IappClient {
    const env = this.getCurrentEnvs();
    let appClientSetting: IappClient;
    if (!!env && env.length > 0) {
      const pool = env.find((poolEl) => poolEl.region === this.getRegion());
      if (!!pool) {
        const user = pool.appClients.find((el) => el.id === window.btoa(this.getAppClientId()));
        if (!!user) {
          appClientSetting = user;
        } else {
          appClientSetting = pool.appClients.length > 0 ? pool.appClients[0] : null;
        }
        if (!!appClientSetting) {
          return appClientSetting;
        } else {
          return null;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  static verifySettings(appClient: string): boolean {
    const env = this.getCurrentEnvs();
    if (!!env) {
      const pool = env.find((poolEl) => poolEl.region === this.getRegion());
      if (!!pool) {
        const user = pool.appClients.find((el) => el.id === window.btoa(appClient));
        return !!user;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  static getLocalSSM(envMode: ModeType, region: string): EnvironmentSetting {
    const selectedEnv = SSMValues[envMode];

    if (selectedEnv) {
      return selectedEnv[region];
    }

    return undefined;
  }

  static verifyEnvironment(): boolean {
    const envs = this.getCurrentEnvs();
    return !!envs && envs[0] !== null;
  }

  static setCurrentEnv(envs: EnvironmentSetting[]): void {
    if (envs) {
      localStorage.setItem('ENVS', JSON.stringify(envs));
    }
  }

  static getCurrentEnvs(): EnvironmentSetting[] {
    let parsedEnvs = null;

    try {
      parsedEnvs = JSON.parse(localStorage.getItem('ENVS'));
    } catch (error) {
      console.error('Error parsing ENVS: ' + error);
    }

    return parsedEnvs;
  }

  static deleteCurrentEndPoints(): void {
    this.CURRENT_TL_URL = null;
    this.CURRENT_URL_OMNI = null;
  }
}
